<h2 mat-dialog-title>{{ creating ? 'Neues Team erstellen' : 'Team bearbeiten' }}</h2>

<mat-dialog-content class="team-form">
  <mat-form-field appearance="outline">
    <mat-label>Teamname</mat-label>
    <input matInput [(ngModel)]="name" maxlength="200" required (keydown.enter)="save()">
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Beschreibung (optional)</mat-label>
    <textarea matInput rows="2" [(ngModel)]="description" maxlength="1000"></textarea>
  </mat-form-field>

  <ng-container *ngIf="creating">
    <mat-form-field appearance="outline">
      <mat-label>Mitglieder</mat-label>
      <mat-select [(ngModel)]="memberIds" multiple>
        <div class="select-search">
          <input class="select-search-input" placeholder="Name oder E-Mail suchen …" [(ngModel)]="memberSearch"
            (click)="$event.stopPropagation()" (keydown)="$event.stopPropagation()">
        </div>
        <mat-option *ngFor="let user of memberOptions" [value]="user.userId">
          {{ user.name }}<span class="option-mail" *ngIf="user.email"> · {{ user.email }}</span>
        </mat-option>
      </mat-select>
      <mat-hint>Weitere Mitglieder kannst du jederzeit in der Teamansicht hinzufügen.</mat-hint>
    </mat-form-field>

    <mat-form-field appearance="outline" *ngIf="data.canChooseLeader">
      <mat-label>Teamleitung</mat-label>
      <mat-select [(ngModel)]="leaderId">
        <mat-option *ngFor="let user of leaderOptions" [value]="user.userId">{{ user.name }}</mat-option>
      </mat-select>
    </mat-form-field>
    <p class="form-hint" *ngIf="!data.canChooseLeader">
      <mat-icon>verified_user</mat-icon>
      Du wirst Teamleitung und kannst das Team danach vollständig einrichten. Überträgst du die
      Teamleitung später, endet deine Verwaltungsberechtigung für dieses Team.
    </p>
  </ng-container>

  <ng-container *ngIf="!creating">
    <mat-slide-toggle [(ngModel)]="isActive">Team aktiv</mat-slide-toggle>
    <p class="form-hint muted" *ngIf="!isActive">
      <mat-icon>info_outline</mat-icon>
      Inaktive Teams erscheinen nicht in Planung, Kapazität und Urlaubsfreigabe.
    </p>
  </ng-container>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="cancel()">Abbrechen</button>
  <button mat-flat-button color="primary" [disabled]="!name.trim()" (click)="save()">
    {{ creating ? 'Team erstellen' : 'Speichern' }}
  </button>
</mat-dialog-actions>
